export default __webpack_public_path__ + "static/media/techwarno.e85796df.jpg";